export default {
  setWorkspaceFeedIsSendPrivate(state, payload) {
    state.workspaceFeedIsSendPrivate = payload;
  },
};
